/* eslint-disable import/prefer-default-export */
export const products = [
    {
        order: 1,
        name: 'Hempel’s Primer Undercoat',
        productId: '13201',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/13201-Primer-Undercoat-25.png',
        description:
            'A single component primer for all substrates (including steel) above the waterline, and an undercoat for Hempel’s Brilliant Gloss/Hempel’s Multicoat/Hempel’s Non-Slip Deck Coating. A quick-drying, high-opacity primer and undercoat, that gives excellent durability and surface stability ready for overcoating with single component topcoats.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: ['10000', '11480'] },
            { Denmark: ['10000', '11480'] },
            { Finland: ['10000', '11480'] },
            { Norway: ['10000', '11480'] },
            { Sweden: ['10000', '11480'] },
            { Germany: ['10000', '11480'] },
            { Spain: ['10000', '11480'] },
            { Netherlands: ['10000', '11480'] },
            { UK: ['10000', '11480'] },
            { US: ['10000', '11480'] }
        ],
        coverage: '12',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 2,
        name: 'Hempel’s Underwater Primer',
        productId: '26030',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/26030-Underwater-Primer-25.png',
        description:
            'Use as part of a single component system below the waterline, including keels; and as a tiecoat before antifouling. Can be applied directly onto the hull or a primed surface, and between an existing antifouling and a new antifouling. Fast-drying with excellent waterproofing.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: ['wood'],
        sailFrequency: [],
        shades: [
            { Croatia: ['19000'] },
            { Denmark: ['19000'] },
            { Finland: ['19000'] },
            { Norway: ['19000'] },
            { Sweden: ['19000'] },
            { Germany: ['19000'] },
            { Spain: ['19000'] },
            { Netherlands: ['19000'] },
            { UK: ['19000'] },
            { US: ['19000'] }
        ],
        coverage: '7,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 3,
        name: 'Hempel’s Prop Primer',
        productId: '101EX',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/101EX-Prop-Primer.png',
        description:
            'Aerosol. An anti-corrosive primer for a large variety of substrates. Particularly recommended as a primer for outdrives and propellers. Hempel’s Prop Primer has very good adherence to most substrates. Fast drying, easy to apply with a matt finish. Overcoat with appropriate antifouling.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: ['11320'] },
            { Denmark: ['11320'] },
            { Finland: ['11320'] },
            { Norway: ['11320'] },
            { Sweden: ['11320'] },
            { Germany: ['11320'] },
            { Spain: ['11320'] },
            { Netherlands: ['11320'] },
            { UK: ['11320'] },
            { US: ['11320'] }
        ],
        coverage: '3,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 4,
        name: 'Hempel’s Light Primer',
        productId: '45551',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/45551-Light-Primer-025.png',
        description:
            'A two component high performance epoxy primer and undercoat for use both above and below the waterline. Use on fibreglass, wood, steel and aluminium. Superb corrosion, impact and water resistance.Can also be used for osmosis protection when application is required at low temperatures.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: ['fibreglass', 'wood', 'steel', 'iron','aluminium'],
        sailFrequency: [],
        shades: [
            { Croatia: ['11630', '12170', '30180'] },
            { Denmark: ['11630', '12170', '30180'] },
            { Finland: ['11630', '12170', '30180', '19990'] },
            { Norway: ['11630', '12170', '30180'] },
            { Sweden: ['11630', '12170', '30180'] },
            { Germany: ['11630', '12170', '30180'] },
            { Spain: ['11630', '12170', '30180'] },
            { Netherlands: ['11630', '12170', '30180'] },
            { UK: ['11630', '12170', '30180', '19990'] },
            { US: ['11630', '12170', '30180', '19990'] }
        ],
        coverage: '8,2',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 5,
        name: 'Hempel’s Light Primer Spray',
        productId: '455EX',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/455EX-Light-Primer-Spray.png',
        description:
            'A two-component epoxy primer spray suited for maintenance, spot repair, touching-up and as a primer for small uncoated surface areas. Can be also used as a primer on propellers before antifouling application. Suitable on glass fibre, steel, aluminium and plywood. For interior and exterior use above and below the waterline.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: ['fibreglass', 'plywood', 'steel', 'iron','aluminium'],
        sailFrequency: [],
        shades: [
            { Croatia: ['11630'] },
            { Denmark: ['11630'] },
            { Finland: ['11630'] },
            { Norway: ['11630'] },
            { Sweden: ['11630'] },
            { Germany: ['11630'] },
            { Spain: ['11630'] },
            { Netherlands: ['11630'] },
            { UK: ['11630'] },
            { US: ['11630'] }
        ],
        coverage: '',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 6,
        name: 'Hempel’s Sealer',
        productId: '(0)5991',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK',
            'US'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/05991-Sealer.png',
        description:
            'Is a two-component epoxy-polyamide with low viscosity and good penetration ability. For saturation of glass fibre laminate, when gel coat has been removed (repair of osmosis damage). For priming of ferro-cement boats and boats of wood that can absorb the sealer.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ],
        coverage: '10',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 7,
        name: 'Hempel’s High Protect II',
        productId: '35780',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/35780-High-Protect-25.png',
        description:
            'A solvent free two component high build epoxy. For use above and below the waterline. An excellent osmosis protection or treatment which can be applied at, and will dry to, a very high film thickness. Can be a substitute for Hempel’s Light Primer where solvent emissions are a consideration. Do not thin.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: ['13700', '14700'] },
            { Denmark: ['13700', '14700'] },
            { Finland: ['13700', '14700'] },
            { Norway: ['13700', '14700'] },
            { Sweden: ['13700', '14700'] },
            { Germany: ['13700', '14700'] },
            { Spain: ['13700', '14700'] },
            { Netherlands: ['13700', '14700'] },
            { UK: ['13700', '14700'] },
            { US: ['13700', '14700'] }
        ],
        coverage: '6,6',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 8,
        name: 'Hempel’s Profair',
        productId: '35290',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/35290-Profair-1L.png',
        description:
            'A light weight two component epoxy filler, with good adhesion and water resistance, and when fully cured easy to sand. Can be applied in coats up to 25mm without sagging. Especially suited for detailed faring where structural strength and flexibility is required. Suitable on glass fibre, hardwood, steel and other rigid materials. For use above and below the waterline.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: ['30540'] },
            { Denmark: ['30540'] },
            { Finland: ['30540'] },
            { Norway: ['30540'] },
            { Sweden: ['30540'] },
            { Germany: ['30540'] },
            { Spain: ['30540'] },
            { Netherlands: ['30540'] },
            { UK: ['30540'] },
            { US: ['30540'] }
        ],
        coverage: '1',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 9,
        name: 'Hempel’s Epoxy Filler',
        productId: '35253',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/35251-Epoxy-Filler-Box.png',
        description:
            'A two component, solvent free, epoxy filler. Use for a variety of filling and fairing jobs both above and below the waterline. Can be applied in thick coats up to approximately 5mm without runs or sags. Fair before overcoating with relevant primer.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: ['19810'] },
            { Denmark: ['19810'] },
            { Finland: ['19810'] },
            { Norway: ['19810'] },
            { Sweden: ['19810'] },
            { Germany: ['19810'] },
            { Spain: ['19810'] },
            { Netherlands: ['19810'] },
            { UK: ['19810'] },
            { US: ['19810'] }
        ],
        coverage: '',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] },
            { US: [] }
        ]
    },
    {
        order: 10,
        name: 'Hempel’s Classic',
        productId: '71120',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Finland',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'economic',
        priority: 0,
        img: '/images/products/71220-Classic-25.png',
        description:
            'Efficient polishing (erodible) antifouling providing good protection all season. As an antifouling for boats of glass fibre, wood, plywood and steel. Do not use on aluminium or other light-alloy metals. Risk of corrosion in case of direct contact. Suitable for cruising speeds.',
        boatType: ['sailing'],
        waterRestrictions: ['Sweden - West Coast', 'sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'steel'],
        sailFrequency: ['low'],
        shades: [
            { Croatia: ['50000'] },
            { Denmark: ['19990', '30390', '41820', '50000'] },
            { Finland: ['19990', '30390', '41820', '50000'] },
            { Norway: ['19990', '30390', '41820', '50000'] },
            { Sweden: ['19990', '30390', '50000'] },
            { Germany: ['19990', '30390', '51170'] },
            { Spain: ['19990', '50000'] },
            { Netherlands: ['19990', '30390', '41820', '50000'] },
            { UK: ['19990', '30390', '31750', '50000'] },
            { US: ['19990', '30390', '31750', '50000'] }
        ],
        coverage: '12,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Dobra zaštita', 'Idealan za laganu plovidbu'] },
            { Denmark: ['Selvpolerende bundmaling', 'God beskyttelse', 'For marchhastigheder'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Hyvä suojaus', 'Alhaisemmille matkanopeuksille'] },
            { Norway: ['Selvpolerende bunnstoff', 'God beskyttelse', 'For cruising hastigheter'] },
            { Sweden: ['Självpolerande bottenfärg', 'Bra skydd', 'För medelhöga marschfarter'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Guter Schutz', 'Für Reisegeschwindigkeiten'] },
            { Spain: ['Antifouling autopulimentante', 'Buena protección', 'Para velocidades de crucero'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Goede bescherming'] },
            { UK: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] },
            { US: ['Self-polishing antifouling', 'Good protection', 'For cruising speeds'] }
        ]
    },
    {
        order: 11,
        name: 'Hempel’s Mille Vit',
        productId: '71600',
        countryAllowed: [
            'Sweden'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71600-Mille-Vit-075.png',
        description:
            'Är en självpolerande bottenfärg som ger ett utmärkt skydd under hela säsongen. Som bottenfärg på glasfiber-, trä-, plywood, stål och epoxigrundmålade aluminiumbåtar. Får endast användas på Västkusten ner till Trelleborg.',
        boatType: ['sailing', 'motor-slow'],
        waterRestrictions: ['Sweden - West Coast'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Sweden: ['10000'] }
        ],
        coverage: '15,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita', 'Sjajna bijela'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse', 'Klare hvid'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus', 'Kirkkaampi valkoinen'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse', 'Lysere hvit'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd', 'Klarare vit'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz', 'Helleres Weiß'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional', 'Blanco más brillante'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming', 'Helderder wit'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection', 'Brighter white'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection', 'Brighter white'] }
        ]
    },
    {
        order: 12,
        name: 'Hempel’s Mille Light Copper',
        productId: '71430',
        countryAllowed: [
            'Sweden'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71430-Mille-Light-Copper-075.png',
        description:
            'Erroderande kopparbaserad bottenfärg. För alla fartområden och alla material utom aluminium. Hempel’s Mille Light Copper får användas från Örskär till Norskagränsen. Overmålningsbar på alla polerande bottenfärger',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['Sweden - West Coast', 'Sweden - East Coast'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Sweden: ['10160', '19990', '30390', '31750', '51170'] }
        ],
        coverage: '12,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita', 'Za sjeverna mora'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus', 'För Östersjön'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz', 'Für die Ostsee'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming', 'Voor de Oostzee'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection', 'For Baltic Sea'] },
            { US: ['Self-polishing antifouling', 'Excellent protection', 'For Baltic Sea'] }
        ]
    },
    {
        order: 13,
        name: 'Hempel’s Mille Standard',
        productId: '7175A',
        countryAllowed: [
            'Norway'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7175A-Mille-Standard-075.png',
        description:
            'Meget effektivt selvpolerende bunnstoff basert på spesialbindemidler. Gir en aktiv overflate som blir kontinuerlig fornyet slik at du får et rent og raskt skrog hele sesongen.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Norway: ['19990', '37110'] }
        ],
        coverage: '14',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 14,
        name: 'Hempel’s Mille NCT',
        productId: '71890',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '31750', '56460'] },
            { Denmark: ['12400', '19990', '37110', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '31750', '56460'] },
            { Sweden: ['10160', '19990', '30390', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['19990', '30390', '31750', '56460'] },
            { UK: ['12400', '19990', '30390', '31750', '56460'] },
            { US: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '13,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 15,
        name: 'Hempel’s Mille NCT',
        productId: '7183A',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '31750', '56460'] },
            { Denmark: ['12400', '19990', '37110', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '31750', '56460'] },
            { Sweden: ['10160', '19990', '30390', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['19990', '30390', '31750', '56460'] },
            { UK: ['12400', '19990', '30390', '31750', '56460'] },
            { US: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '13,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 16,
        name: 'Hempel’s Mille NCT',
        productId: '7173A',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '31750', '56460'] },
            { Denmark: ['12400', '19990', '37110', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '31750', '56460'] },
            { Sweden: ['10160', '19990', '30390', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['19990', '30390', '31750', '56460'] },
            { UK: ['12400', '19990', '30390', '31750', '56460'] },
            { US: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '13,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 17,
        name: 'Hempel’s Mille NCT',
        productId: '7173C',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '31750', '56460'] },
            { Denmark: ['12400', '19990', '37110', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '31750', '56460'] },
            { Sweden: ['10160', '19990', '30390', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['19990', '30390', '31750', '56460'] },
            { UK: ['12400', '19990', '30390', '31750', '56460'] },
            { US: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '13,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 18,
        name: 'Hempel’s Mille NCT',
        productId: '7183E',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Sweden',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71890-Mille-NCT-075.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling and colour retention all season. For use on all substrates below the waterline excluding aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '31750', '56460'] },
            { Denmark: ['12400', '19990', '37110', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '31750', '56460'] },
            { Sweden: ['10160', '19990', '30390', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['19990', '30390', '31750', '56460'] },
            { UK: ['12400', '19990', '30390', '31750', '56460'] },
            { US: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '13,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 19,
        name: 'Hempel’s Mille NCT (white)',
        productId: '7174A',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7174A-Mille-NTC-White-075.png',
        description:
            'Is high performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling protection and colour retention all season. As an antifouling for boats of glass fibre, wood, plywood, steel and aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['10101'] },
            { Denmark: ['10101'] },
            { Norway: ['10101'] },
            { Germany: ['10101'] },
            { Spain: ['10101'] },
            { Netherlands: ['10101'] },
            { UK: ['10101'] },
            { US: ['10101'] }
        ],
        coverage: '13,3',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 20,
        name: 'Hempel’s Mille NCT (white)',
        productId: '7174C',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Spain',
            'Germany',
            'Netherlands',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7174A-Mille-NTC-White-075.png',
        description:
            'Is high performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling protection and colour retention all season. As an antifouling for boats of glass fibre, wood, plywood, steel and aluminium.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['10101'] },
            { Denmark: ['10101'] },
            { Norway: ['10101'] },
            { Germany: ['10101'] },
            { Spain: ['10101'] },
            { Netherlands: ['10101'] },
            { UK: ['10101'] },
            { US: ['10101'] }
        ],
        coverage: '13,3',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 21,
        name: 'Hempel’s Mille Xtra',
        productId: '7166A',
        countryAllowed: [
            'Denmark',
            'Finland',
            'Netherlands'
        ],
        position: 'CHECK',
        priority: 0,
        img: '/images/products/7166A-MilleXtra-25.png',
        description:
            'Hempel’s mest solgte bundmaling til lystbåde! Udviklet specielt til bådejere, der stiller meget høje krav til beskyttelse mod begroninger i saltvand. En polerende bundmaling, som er let at arbejde med. Velegnet til en fart op til 25 knob.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'Sweden - West Coast'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'iron', 'steel'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Denmark: ['12400', '19990', '30390', '31750', '56460'] },
            { Finland: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '14',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 22,
        name: 'Hempel’s Mille Xtra',
        productId: '7166C',
        countryAllowed: [
            'Denmark',
            'Finland',
            'Netherlands'
        ],
        position: 'CHECK',
        priority: 0,
        img: '/images/products/7166A-MilleXtra-25.png',
        description:
            'Hempel’s mest solgte bundmaling til lystbåde! Udviklet specielt til bådejere, der stiller meget høje krav til beskyttelse mod begroninger i saltvand. En polerende bundmaling, som er let at arbejde med. Velegnet til en fart op til 25 knob.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean (Denmark)', 'Sweden - West Coast'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Denmark: ['12400', '19990', '30390', '31750', '56460'] },
            { Finland: ['12400', '19990', '30390', '31750', '56460'] },
            { Netherlands: ['12400', '19990', '30390', '31750', '56460'] }
        ],
        coverage: '14',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection'] }
        ]
    },
    {
        order: 23,
        name: 'Hempel’s Mille Xtra (white)',
        productId: '7166W',
        countryAllowed: [
            'Finland'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7166W-Mille-Xtra-075.png',
        description:
            'Valkoinen, itsekiillottuva antifouling-maali. Valkoinen sävy ei ole yhtä tehokas kuin muut sävyt, eli se toimii parhaiten kylmissä vesistöissä ja sitä on maalattava väh. 2 kerrosta/kausi. Vesillelasku aikaisintaan 24 tunnin jälkeen - viimeistään 6 kuukauden sisällä.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: [],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Finland: ['10101'] }
        ],
        coverage: '13',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Izvranredna zaštita', 'Sjajna bijela'] },
            { Denmark: ['Selvpolerende bundmaling', 'Enestående beskyttelse', 'Klare hvid'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erinomainen suojaus', 'Kirkkaampi valkoinen'] },
            { Norway: ['Selvpolerende bunnstoff', 'Førsteklasses beskyttelse', 'Lysere hvit'] },
            { Sweden: ['Självpolerande bottenfärg', 'Enastående skydd', 'Klarare vit'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Herausragender Schutz', 'Helleres Weiß'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excepcional', 'Blanco más brillante'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming', 'Helderder wit'] },
            { UK: ['Self-polishing antifouling', 'Outstanding protection', 'Brighter white'] },
            { US: ['Self-polishing antifouling', 'Outstanding protection', 'Brighter white'] }
        ]
    },
    {
        order: 24,
        name: 'Hempel’s Hard Racing',
        productId: '7668E',
        countryAllowed: [
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7668E-Hard-Racing-2,5.png',
        description:
            'Hard, high strength antifouling which gives a smooth racing finish, offering all round competitive performance. Formulated especially for power boats, racing yachts and vessels which are mud berthed. It may also be used on vessels that are dry sailed. Suitable for all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { UK: ['19990', '30390', '37110', '56460'] },
            { US: ['19990', '30390', '37110', '56460'] }
        ],
        coverage: '12,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 25,
        name: 'Hempel’s Hard Racing Copper',
        productId: '71460',
        countryAllowed: [
            'Sweden'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/71460-Hard-Racing-Copper-075.png',
        description:
            'Är en hård bottenfärg som innehåller koppar och är avsedd för den svenska väst/ostkusten. Färgen kan användas på alla material (för aluminium och lättare legeringar krävs en förseglare). Två strykningar på västkusten och en ostkusten rekommenderas.',
        boatType: ['motor-fast'],
        waterRestrictions: ['Sweden - West Coast', 'Sweden - East Coast'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Sweden: ['10000', '19990', '30390', '51170'] }
        ],
        coverage: '14,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 26,
        name: 'Hempel’s Hard Racing TecCel',
        productId: '76890',
        countryAllowed: [
            'Croatia',
            'Norway',
            'Spain',
            'Germany'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/76890-Hard-Racing-TecCel-075.png',
        description:
            'Hardt bunnstoff som inneholder TecCel for en glatt overflate som reduserer friksjonen. Egnet for motorbåter, seilbåter, og hurtig gående båter. For bruk under vannlinjen på alle underlag inklusiv aluminium.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'iron', 'plastic', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '41820', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '41820', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '41820', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '41820', '31750', '56460'] }
        ],
        coverage: '13,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 27,
        name: 'Hempel’s Hard Racing TecCel',
        productId: '7683A',
        countryAllowed: [
            'Croatia',
            'Norway',
            'Spain',
            'Germany'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/76890-Hard-Racing-TecCel-075.png',
        description:
            'Hardt bunnstoff som inneholder TecCel for en glatt overflate som reduserer friksjonen. Egnet for motorbåter, seilbåter, og hurtig gående båter. For bruk under vannlinjen på alle underlag inklusiv aluminium.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'iron', 'plastic', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['12400', '19990', '30390', '41820', '31750', '56460'] },
            { Norway: ['12400', '19990', '37110', '41820', '31750', '56460'] },
            { Germany: ['12400', '19990', '37110', '41820', '31750', '56460'] },
            { Spain: ['12400', '19990', '30390', '41820', '31750', '56460'] }
        ],
        coverage: '13,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 28,
        name: 'Hempel’s Hard Racing TecCel (white)',
        productId: '7679A',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Spain',
            'Germany',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7679A-HardRacingTeccel-2,5.png',
        description:
            'High performance, hard antifouling providing outstanding protection all season. Includes TecCel technology which ensures reduced friction and increased speed. Can be used on glass fibre, wood, plywood, steel and aluminium. For power boats and regatta yachts.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['10101'] },
            { Denmark: ['10101'] },
            { Norway: ['10101'] },
            { Germany: ['10101'] },
            { Spain: ['10101'] },
            { UK: ['10101'] },
            { US: ['10101'] }
        ],
        coverage: '12,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 29,
        name: 'Hempel’s Hard Racing TecCel (white)',
        productId: '7979A',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Spain',
            'Germany',
            'UK'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7679A-HardRacingTeccel-2,5.png',
        description:
            'High performance, hard antifouling providing outstanding protection all season. Includes TecCel technology which ensures reduced friction and increased speed. Can be used on glass fibre, wood, plywood, steel and aluminium. For power boats and regatta yachts.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel', 'iron','aluminium'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Croatia: ['10101'] },
            { Denmark: ['10101'] },
            { Norway: ['10101'] },
            { Germany: ['10101'] },
            { Spain: ['10101'] },
            { UK: ['10101'] },
            { US: ['10101'] }
        ],
        coverage: '12,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 30,
        name: 'Hempel’s Hard Racing Xtra',
        productId: '7666C',
        countryAllowed: [
            'Denmark',
            'Finland',
            'Netherlands'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7666A-Hard-Racing-Xtra-075.png',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Denmark: ['12400', '19990', '31750', '56460'] },
            { Finland: ['12400', '19990', '31750', '56460', '30390'] },
            { Netherlands: ['12400', '19990', '31750', '56460', '30390'] }
        ],
        coverage: '12,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 31,
        name: 'Hempel’s Hard Racing Xtra',
        productId: '7666A',
        countryAllowed: [
            'Denmark',
            'Finland',
            'Netherlands'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7666A-Hard-Racing-Xtra-075.png',
        description:
            'Er en højtydende, hård antifouling, der giver fremragende beskyttelse og en glat racerfinish hele sæsonen. Som antifouling til både af glasfiber, træ, krydsfiner og stål. Må ikke anvendes på aluminium eller andre metallegeringer. Risiko for korrosion i tilfælde af direkte kontakt. Til motorbåde og regatta-yachter.',
        boatType: ['motor-fast'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['fibreglass', 'wood', 'plywood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { Denmark: ['12400', '19990', '31750', '56460'] },
            { Finland: ['12400', '19990', '31750', '56460', '30390'] },
            { Netherlands: ['12400', '19990', '31750', '56460', '30390'] }
        ],
        coverage: '12,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] },
            { US: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 32,
        name: 'Hempel’s Hard Racing Xtra (white)',
        productId: '7666W',
        countryAllowed: [
            'Finland'
        ],
        position: 'premium',
        priority: 0,
        img: '/images/products/7666W-Hard-Racing-Xtra-White-075.png',
        description:
            'Valkoinen, kova antifouling-maali. Erityisen sopiva nopeille moottoriveneille, kilpapurjeveneille ja traileriveneille. Hiottavissa erittäin sileäksi. Sopii kaikille pinnoille, paitsi alumiini. Käytetään vesilinjan alapuolella. Valkoinen sävy ei ole yhtä tehokas kuin muut sävyt, eli se toimii parhaiten kylmissä vesistöissä ja sitä on maalattava väh. 2 kerrosta/kausi. Vesillelasku aikaisintaan 24 tunnin jälkeen - viimeistään 6 kuukauden sisällä.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Finland: ['10101'] }
        ],
        coverage: '13',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Protuobraštajni premaz tvrdoga tipa', 'Odlična zaštita', 'Motorne i regatne jahte'] },
            { Denmark: ['Hård bundmaling', 'Meget god beskyttelse', 'Motor og regatta både'] },
            { Finland: ['Kova antifouling-maali', 'Erittäin hyvä suojaus', 'Moottori- ja kilpapurjeveneille'] },
            { Norway: ['Hardt bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Erittäin hyvä suojaus', 'Motor- och kappseglingsbåtar'] },
            { Germany: ['Hart-Antifouling', 'Ausgezeichneter Schutz', 'Motor- und Regattayachten'] },
            { Spain: ['Antiincrustante de matriz dura', 'Protección excelente', 'Motoras y barcos de regata'] },
            { Netherlands: ['Harde Antifouling', 'Uitstekende bescherming', 'Motorboten en wedstrijdjachten'] },
            { UK: ['Hard antifouling', 'Excellent protection', 'Power and regatta yachts'] }
        ]
    },
    {
        order: 33,
        name: 'Hempel’s Cruising Performer',
        productId: '7168E',
        countryAllowed: [
            'Spain',
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7168E-Cruising-Performer-25.png',
        description:
            'Self-polishing, erodible antifouling with very latest eroding technology which reduces the build up of paint, maximizing cruising capability in all areas, whilst ensuring fouling is kept to a minimum. An excellent coverage rate and colour stability ensures Hempel’s Cruising Performer offers you the very best in value. Suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plastic', 'plywood', 'iron', 'steel'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Spain: ['19990', '30390', '56460'] },
            { UK: ['19990', '30390', '31750', '51170'] }
        ],
        coverage: '14,3',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection'] }
        ]
    },
    {
        order: 34,
        name: 'Hempel’s Tiger Xtra',
        productId: '71000',
        countryAllowed: [
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/71000-Tiger-Xtra-25.png',
        description:
            'Self-polishing, erodible antifouling. Suitable to both power and sail boats and just 1 coat can last the season. Applying a second coat for year round protection gives excellent and consistent long term performance, under all conditions. It is suitable for use on all substrates except aluminium. Maximum launch time 6 months.',
        boatType: ['motor-fast', 'motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plastic', 'ferrocement', 'steel'],
        sailFrequency: ['low', 'medium', 'high'],
        shades: [
            { UK: ['12400', '19990', '30390', '31750', '37110', '41820', '56460'] }
        ],
        coverage: '12,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Odlična zaštita'] },
            { Denmark: ['Meget god beskyttelse'] },
            { Finland: ['Erittäin hyvä suojaus'] },
            { Norway: ['Meget god beskyttelse'] },
            { Sweden: ['Erittäin hyvä suojaus'] },
            { Germany: ['Ausgezeichneter Schutz'] },
            { Spain: ['Protección excelente'] },
            { Netherlands: ['Uitstekende bescherming'] },
            { UK: ['Erodible antifouling', 'Excellent protection'] }
        ]
    },
    {
        order: 35,
        name: 'Hempel’s Tiger Xtra (white)',
        productId: '7103A',
        countryAllowed: [
            'UK'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7102A-Tiger-Xtra-White-25.png',
        description:
            'High performance, self-polishing antifouling providing excellent protection all season. As an antifouling for boats of glass fibre, wood, plywood, steel and aluminium.',
        boatType: ['motor-fast', 'motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plastic', 'ferrocement', 'steel'],
        sailFrequency: ['low', 'high'],
        shades: [
            { UK: ['10102'] }
        ],
        coverage: '13,3',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Odlična zaštita'] },
            { Denmark: ['Meget god beskyttelse'] },
            { Finland: ['Erittäin hyvä suojaus'] },
            { Norway: ['Meget god beskyttelse'] },
            { Sweden: ['Erittäin hyvä suojaus'] },
            { Germany: ['Ausgezeichneter Schutz'] },
            { Spain: ['Protección excelente'] },
            { Netherlands: ['Uitstekende bescherming'] },
            { UK: ['Erodible antifouling', 'Excellent protection'] }
        ]
    },
    {
        order: 36,
        name: 'Hempel’s Broads',
        productId: '76111',
        countryAllowed: [
            'UK'
        ],
        position: 'economic',
        priority: 0,
        img: '/images/products/76111-Broads-25.png',
        description:
            'Medium strength antifouling specifically designed to reduce paint build up and give a good performance on fresh, salt and brackish waters. It is suitable for all substrates except aluminium. The maximum launch time is one month.',
        boatType: ['sailing'],
        waterRestrictions: ['rivers'],
        materialAllowed: ['fibreglass', 'wood', 'plastic', 'iron', 'steel'],
        sailFrequency: ['low'],
        shades: [
            { UK: ['50000', '19990', '30390', '41820'] }
        ],
        coverage: '12,5',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz'] },
            { Denmark: ['Selbstpolierendes Antifouling', 'For cruising speeds'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Risteilynopeutta varten'] },
            { Norway: ['Selvpolerende bunnstoff'] },
            { Sweden: ['Självpolerande bottenfärg', 'För medelhöga marschfarter'] },
            { Germany: ['Selbstpolierendes Antifouling'] },
            { Spain: ['Antiincrustante autopulimentante'] },
            { Netherlands: ['Zelfpolijstende Antifouling'] },
            { UK: ['Self-polishing antifouling', 'For cruising speeds'] }
        ]
    },
    {
        order: 37,
        name: 'Hempel’s Prop NCT',
        productId: '7455X',
        countryAllowed: [
            'Croatia',
            'Denmark',
            'Norway',
            'Spain',
            'Germany'
        ],
        position: '',
        priority: 0,
        img: '/images/products/7455X-Prop-NCT.png',
        description:
            'Leistungsstarkes, selbstpolierendes Antifouling für Propeller und Z-Antriebe. Durch den selbsterneuernden Effekt bietet es einen guten Schutz vor Bewuchs innerhalb der Saison. Es ist einfach aufzutragen, hat schnelle  Überarbeitungsintervalle und baut keine hohe Schichtstärke auf.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Croatia: ['10430', '19990'] },
            { Denmark: ['10430', '19990'] },
            { Norway: ['10430', '19990'] },
            { Germany: ['10430', '19990'] },
            { Spain: ['10430', '19990'] }
        ],
        coverage: '1,4',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] }
        ]
    },
    {
        order: 38,
        name: 'Hempel’s Alu Prop NCT',
        productId: '7473A',
        countryAllowed: [
            'Croatia',
            'Spain',
            'Germany',
            'UK'
        ],
        position: '',
        priority: 0,
        img: '/images/products/7473A-Alu-Prop-NCT-2,5.png',
        description:
            'High performance, self-polishing antifouling. Hempel’s patented binder technology ensures outstanding fouling protection and colour retention all season. Especially suited for aluminium boats. As an antifouling for boats of glass fibre, wood, plywood, steel and aluminium vessels.',
        boatType: ['motor-fast', 'motor-slow', 'sailing'],
        waterRestrictions: ['sea/ocean'],
        materialAllowed: ['fibreglass', 'wood', 'plastic', 'ferrocement', 'steel', 'iron','rubber', 'neoprene', 'hypalon'],
        sailFrequency: ['low', 'high'],
        shades: [
            { Croatia: ['10430', '19990'] },
            { Germany: ['10430', '19991'] },
            { Spain: ['10430', '19991'] },
            { UK: ['10430', '19991'] }
        ],
        coverage: '13',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: [] },
            { Denmark: [] },
            { Finland: [] },
            { Norway: [] },
            { Sweden: [] },
            { Germany: [] },
            { Spain: [] },
            { Netherlands: [] },
            { UK: [] }
        ]
    },
    {
        order: 39,
        name: 'Hempel’s Aluxtra NCT',
        productId: '74770',
        countryAllowed: [
            'Norway'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/74770-Aluxtra-NCT-25.png',
        description:
            'Er et selvpolerende bunnstoff med høy ytelse. Hempels patenterte bindemiddelsteknologi sikrer fremragende beskyttelse mot begroing og bevarer fargen gjennom hele sesongen. Spesielt godt egnet for aluminiumsbåter. Kan brukes på alle typer underlag under vannlinjen. Sørg for at aluminiumoverflater er grunnet.',
        boatType: [],
        waterRestrictions: [],
        materialAllowed: [],
        sailFrequency: [],
        shades: [
            { Norway: ['10430', '19990', '30390'] }
        ],
        coverage: '13,3',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz', 'Odlična zaštita', 'Idealan za aluminijska plovila'] },
            { Denmark: ['Selvpolerende bundmaling', 'Meget god beskyttelse', 'Ideel for aluminiums både'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Erittäin hyvä suojaus', 'Ihanteellinen alumiiniveneille'] },
            { Norway: ['Selvpolerende bunnstoff', 'Meget god beskyttelse', 'Ideell for aluminium båter'] },
            { Sweden: ['Självpolerande bottenfärg', 'Erittäin hyvä suojaus', 'Idealisk för aluminiumbåtar'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Ausgezeichneter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Protección excelente', 'Ideal para barcos de aluminio'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Uitstekende bescherming'] },
            { UK: ['Self-polishing antifouling', 'Excellent protection', 'Ideal for aluminium boats'] }
        ]
    },
    {
        order: 40,
        name: 'Hempel’s Alusafe',
        productId: '7120D',
        countryAllowed: [
            'Denmark',
            'Finland',
            'Norway'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/7120D-Alusafe-075.png',
        description:
            'Velkomponert bunnstoff uten kobber for beskyttelse mot begroing på aluminiumsskrog og utenbordsdetaljer som propeller, drev, logger og rorfester i lettmetall.',
        boatType: ['sailing'],
        waterRestrictions: ['sea/ocean (Denmark)'],
        materialAllowed: ['aluminium'],
        sailFrequency: ['low', 'medium'],
        shades: [
            { Denmark: ['10430', '19990'] },
            { Finland: ['10430', '19990', '30390'] },
            { Norway: ['10430', '19990', '30390'] }
        ],
        coverage: '13,3',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['Samopolirajući protuobraštajni premaz','Dobra zaštita',
            'Idealan za aluminijska plovila'] },
            { Denmark: ['Selvpolerende bundmaling', 'God beskyttelse', 'Ideel for aluminiums både'] },
            { Finland: ['Itsekiillottuva antifouling-maali', 'Hyvä suojaus','Ihanteellinen alumiiniveneille'] },
            { Norway: ['Selvpolerende bunnstoff', 'God beskyttelse', 'Ideell for aluminium båter'] },
            { Sweden: ['Självpolerande bottenfärg', 'Bra skydd', 'Idealisk för aluminiumbåtar'] },
            { Germany: ['Selbstpolierendes Antifouling', 'Guter Schutz'] },
            { Spain: ['Antiincrustante autopulimentante', 'Buena protección', 'Ideal para barcos de aluminio'] },
            { Netherlands: ['Zelfpolijstende Antifouling', 'Goede bescherming'] },
            { UK: ['Self-polishing antifouling', 'Good protection', 'Ideal for aluminium boats'] }
        ]
    },
    {
        order: 41,
        name: 'Hempel’s Bravo II',
        productId: '76160',
        countryAllowed: [
            'Spain'
        ],
        position: 'best-buy',
        priority: 0,
        img: '/images/products/76160-Bravo-2-25.png',
        description:
            'Antiincrustante de matriz insoluble. Proporciona una buena protección de fondos y líneas de flotación en las embarcaciones cuya velocidad no supera 20-30 nudos. Producto desarrollado especialmente para las aguas templadas. Para aplicar sobre todos los sustratos excepto el aluminio.',
        boatType: ['sailing'],
        waterRestrictions: ['rivers', 'lakes', 'sea/ocean'],
        materialAllowed: ['wood', 'plastic', 'fibreglass', 'steel', 'iron','iron'],
        sailFrequency: ['low'],
        shades: [
            { Spain: ['51170', '19990', '30390', '31750'] }
        ],
        coverage: '18,8',
        alternativeProducts: '',
        keyFeatures: [
            { Croatia: ['10000', '11480'] },
            { Denmark: ['Hardt bunnstoff', 'God beskyttelse'] },
            { Finland: ['Kova antifouling-maali', 'Hyvä suoja'] },
            { Norway: ['Hardt bunnstoff', 'God beskyttelse'] },
            { Sweden: ['Hård bottenfärg', 'Bra skydd'] },
            { Germany: ['Hart-Antifouling', 'Guter Schutz'] },
            { Spain: ['Antiincrustante de matriz dura', 'Buena protección', 'Para barcos de alta actividad'] },
            { Netherlands: ['Harde Antifouling', 'Goede bescherming'] },
            { UK: ['Hard antifouling', 'Good protection', 'For high activity boats'] }
        ]
    }
]
